import { v4 as uuidv4 } from 'uuid'

import { createCookieName } from '@app/utils/cookieNames'
import { createCookie } from '@app/utils/cookies'
import { createSelector } from '@app/utils/createSelector'
import moment from '@app/utils/moment'
import { tryJSONparse } from '@app/utils/tryJSONparse'

import { unwrapOr } from '@app/packages/Result/Result'

import { getCookies } from '@app/store/actions/contexts/cookies'
import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const shortSessionSlice = createReduxSlice<{ uuid: string }>('short_session')

export const shortSessionUuidSelector = createSelector([shortSessionSlice.selector], slice => slice?.uuid ?? '')

export const setShortSession = (uuid: string) => shortSessionSlice.set({ uuid })

export function restoreShortSession() {
  return createThunk(async (dispatch, getState) => {
    const cookies = dispatch(getCookies())
    const uuid = shortSessionUuidSelector(getState())

    if (uuid) return { uuid }

    const session = await shortSessionCookie.get(cookies)
    if (session) {
      dispatch(setShortSession(session.uuid))
    } else {
      const consents = await import('@app/store/slices/user_consents')
      const newSession = { uuid: uuidv4() }

      await shortSessionCookie.set(cookies, newSession)
      dispatch(setShortSession(newSession.uuid))
      dispatch(consents.setEmptyConsents(newSession.uuid))
    }
  })
}

const shortSessionCookie = createCookie<{ uuid: string } | null>(
  createCookieName('kidsout__short_session'),
  input => unwrapOr(tryJSONparse<{ uuid: string } | null>(input), null),
  value => JSON.stringify(value),
  () => ({
    expires: moment().add(1, 'year'),
    sameSite: 'lax',
  })
)
